import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';
import { CommunityTag } from '@/design-system';

const styles = {
  wrapper: css`
    position: relative;
    margin: 16px 16px 12px 16px;
  `,
  container: css`
    display: flex;
    flex-direction: row;
    min-height: ${pxToRem(158)};
    width: 100%;
    border-radius: 5px;
    margin-bottom: 12px;
    cursor: pointer;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
  titleRow: css`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    column-gap: 8px;
  `,
  favoriteIcon: css`
    margin-left: auto;
    height: 20px;
    flex-shrink: 0;
  `,
  orgName: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media only screen and (max-width: 480px) {
      max-width: 70%;
    }
  `,
  title: css`
    max-width: 85%;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  `,
  flyer: css`
    img {
      object-fit: contain;
      border-radius: 5px;
      margin-right: 8px;
    }
  `,
  skeletonContent: css`
    padding: 0px 0px 8px 16px;
    width: 100%;
  `,
  content: css`
    display: flex;
    flex-direction: row;
    width: 100%;
  `,
  agesOrGradesContainer: css`
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  `,


  schoolLogo: css`
    object-fit: cover;
    max-height: 24px;
    width: auto;
    max-width: 24px;
  `,
  loader: css`
    min-height: ${pxToRem(158)};
  `,
  disabledFlyer: css`
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.35);
      pointer-events: none;
      z-index: 0;
    }

    & > * {
      position: relative;
      z-index: 1;
    }
  `,
  disabledMedia: css`
    img {
      filter: grayscale(1);
      opacity: 0.6;
    }
  `,
  schoolIconContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  `,
  removedFlyerLabel: css`
    margin-top: 24px;
  `,
  communityTag: css`
    display: flex;
    gap: 8px;
  `,
};

export default styles;
